import React, { useState, useEffect } from "react";

import * as APIModels from "../../../../models";

import { useCallback } from "react";

export default function Details({
    submission,
}: {
    submission: APIModels.Submission;
}) {
    const [updatedSubmission, setUpdatedSubmission] = useState(submission);
    const [saving, setSaving] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        setUpdatedSubmission(submission);
    }, [submission]);

    const onSaveClick = useCallback(async () => {
        setSaving(true);
    }, [updatedSubmission]);

    return (
        <div className="card text-center">
            <div className="card-body">
                <div className="row mb-3">
                    <div className="col-sm-6">
                        <label
                            htmlFor="txtDetailFilename"
                            className="form-label"
                        >
                            Filename
                        </label>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtDetailFilename"
                                placeholder="Filename"
                                aria-describedby="inputGroupPrepend"
                                readOnly={true}
                                value={updatedSubmission.filename}
                                onChange={(event) =>
                                    setUpdatedSubmission({
                                        ...updatedSubmission,
                                        filename: event.currentTarget.value,
                                    })
                                }
                            />
                            <div className="invalid-feedback">
                                Please provide a valid first name.
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-4">
                        <label
                            htmlFor="txtDetailsReferenceNumber"
                            className="form-label"
                        >
                            Reference Number
                        </label>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtDetailsReferenceNumber"
                                placeholder="Reference Number"
                                aria-describedby="inputGroupPrepend"
                                value={updatedSubmission.referenceNumber}
                                onChange={(event) =>
                                    setUpdatedSubmission({
                                        ...updatedSubmission,
                                        referenceNumber:
                                            event.currentTarget.value,
                                    })
                                }
                            />
                            <div className="invalid-feedback">
                                Please provide a valid middle name.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-4"></div>
                </div>
                <div className="row">
                    <div className="col-sm-4">
                        <label
                            htmlFor="txtDetailsReferenceNumber"
                            className="form-label"
                        >
                            Reference Number
                        </label>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="txtDetailsReferenceNumber"
                                placeholder="attorney"
                                aria-describedby="inputGroupPrepend"
                                value={updatedSubmission.attorneyID}
                                onChange={(event) =>
                                    setUpdatedSubmission({
                                        ...updatedSubmission,
                                        attorneyID: event.currentTarget.value,
                                    })
                                }
                            />
                            <div className="invalid-feedback">
                                Please provide a valid last name.
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-4"></div>
                </div>
            </div>
        </div>
    );
}
